module.exports = __webpack_public_path__ + "5f06ac3aa5c5b97d6a8a0c1f2039a03a.webm";